import React from "react";

const livrosPolemicos = [
  {
    titulo: "O Avesso da Pele",
    autor: "Jeferson Tenório",
    motivo: "Acusado de conter linguagem inadequada e descrições explícitas. Retirado de escolas em RS, PR, MS e GO.",
    fonte: "https://www1.folha.uol.com.br/ilustrada/2024/03/diretora-pede-censura-a-livro-sobre-racismo-em-escola-no-rio-grande-do-sul-nojento.shtml",
  },
  {
    titulo: "Aparelho Sexual e Cia.",
    autor: "Hélène Bruller e Zep",
    motivo: "Acusado de conteúdo impróprio sobre educação sexual. Livro descartado publicamente por prefeita em SC.",
    fonte: "https://www1.folha.uol.com.br/ilustrada/2024/05/literatura-infantil-e-juvenil-na-fogueira-discute-os-impactos-da-censura-a-livros.shtml",
  },
  {
    titulo: "Enfim, Capivaras",
    autor: "Luisa Geisler",
    motivo: "Proibido em escolas do RS por alegações de linguagem inadequada e temas sensíveis.",
    fonte: "https://www1.folha.uol.com.br/ilustrada/2024/05/literatura-infantil-e-juvenil-na-fogueira-discute-os-impactos-da-censura-a-livros.shtml",
  },
  {
    titulo: "Meninos Sem Pátria",
    autor: "Luiz Puntel",
    motivo: "Em 2018, pais de alunos do Colégio Santo Agostinho, no Rio de Janeiro, protestaram contra o livro, alegando que a obra 'doutrinava crianças com ideologia comunista'.",
    fonte: "https://veja.abril.com.br/brasil/escola-catolica-do-rio-censura-livro-acusado-de-ser-de-esquerda",
  },
//   {
//     titulo: "Viva o Povo Brasileiro",
//     autor: "João Ubaldo Ribeiro",
//     motivo: "Embora seja uma obra aclamada, não há registros recentes de polêmicas específicas relacionadas à sua adoção em escolas.",
//     fonte: "",
//   },
//   {
//     titulo: "O Diário de Anne Frank",
//     autor: "Anne Frank",
//     motivo: "Uma adaptação em quadrinhos foi banida de uma escola na Flórida, EUA, em 2023, após queixas sobre conteúdo sexual explícito.",
//     fonte: "https://rfm.pt/atualidade/15161/escola-bane-versao-de-o-diario-de-anne-frank-apos-queixa-sobre-conteudo-sexual-explicito",
//   },
  {
    titulo: "Macunaíma",
    autor: "Mário de Andrade",
    motivo: "Tentativas de censura em escolas públicas geraram revolta na web, devido ao conteúdo da obra.",
    fonte: "https://www.educamaisbrasil.com.br/educacao/escolas/macunaima-por-que-a-tentativa-de-censurar-o-livro-nas-escolas-publicas-gerou-revolta-na-web",
  },
  {
    titulo: "O Beijo no Asfalto",
    autor: "Nelson Rodrigues",
    motivo: "A peça aborda temas como fake news e lawfare, sendo considerada de extrema atualidade.",
    fonte: "https://www.conjur.com.br/2023-jan-08/embargos-culturais-fake-news-lawfare-beijo-asfalto-nelson-rodrigues",
  },
  {
    titulo: "Capitães da Areia",
    autor: "Jorge Amado",
    motivo: "O romance expressa ideal político e já foi alvo de polêmicas em relação ao seu conteúdo.",
    fonte: "https://educacao.uol.com.br/disciplinas/portugues/capitaes-da-areia-romance-expressa-ideal-politico.htm",
  },
  {
    titulo: "Reinações de Narizinho",
    autor: "Monteiro Lobato",
    motivo: "Obra clássica alvo de debates sobre racismo em obras literárias antigas.",
    fonte: "https://www.uol.com.br/ecoa/ultimas-noticias/2021/03/12/bisneta-de-lobato-adaptou-trechos-problematicos-de-obra-veja-comparacao.htm",
  },
];

const BlackListBooks = () => {
  return (
    <div className="max-w-5xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6 text-center text-[#2294ae]">
        Livros Polêmicos em Escolas Brasileiras
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {livrosPolemicos.map((livro, index) => (
          <div
            key={index}
            className="border p-4 rounded-lg shadow hover:shadow-lg transition bg-white"
          >
            <h2 className="text-lg font-semibold">{livro.titulo}</h2>
            <p className="text-sm text-gray-600 mb-2">{livro.autor}</p>
            <p className="mb-2">{livro.motivo}</p>
            <a
              href={livro.fonte}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#2294ae] underline text-sm"
            >
              Ver fonte
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlackListBooks;
